// src/pages/Login/index.tsx
import React, { useRef, useCallback } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { FiMail, FiLock } from 'react-icons/fi';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';

import getValidationErrors from '../../../utils/getValidationsErrors'; // Criaremos este arquivo
import { useAuth } from '../../../hooks/Auth'; // Criaremos este hook

import logoImg from '../../../assets/logos/logo.svg'; // Importe seu logo

import Input from '../../../components/NewInput';
import Button from '../../../components/Button';

import { Container, Content } from './styles';

interface LoginFormData {
  email: string;
  password: string;
}

const Login: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { signIn } = useAuth();
  const history = useHistory();

  const handleSubmit = useCallback(
    async (data: LoginFormData) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          email: Yup.string()
            .required('E-mail obrigatório')
            .email('Digite um e-mail válido'),
          password: Yup.string().required('Senha obrigatória'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await signIn({
          email: data.email,
          password: data.password,
        });

        history.push('/dashboard'); // Redireciona para o dashboard após o login
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }

        Swal.fire({
          icon: 'error',
          title: 'Erro na autenticação',
          text: 'Ocorreu um erro ao fazer login, cheque as credenciais.',
        });
      }
    },
    [signIn, history]
  );

  return (
    <Container>
      <Content>
        <img src={logoImg} alt="Logo da Empresa" />

        <Form ref={formRef} onSubmit={handleSubmit}>
          <h1>Login Administrativo</h1>

          <Input name="email" icon={FiMail} placeholder="E-mail" />
          <Input
            name="password"
            icon={FiLock}
            type="password"
            placeholder="Senha"
          />

          <Button type="submit">Entrar</Button>
        </Form>
      </Content>
    </Container>
  );
};

export default Login;
